import RemoveTeamMate from './RemoveTeamMate';
export default RemoveTeamMate;
